import ApiService from "services/ApiService";

export const GreyFleetService = {
    SearchInsuranceDocuments(pageNumber, requestCount, searchTerm, sortField, sortDirection, filters) {
        const searchRequest = {
            "requestCount": requestCount,
            "pageNumber": pageNumber,
            "searchTerm": searchTerm,
            "sortField": sortField,
            "sortDirection": sortDirection,
            "filters": filters
        };
        
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/GreyFleetInsurance/InternalReview/Search`, searchRequest)
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInsuranceForReview(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/GreyFleetInsurance/InternalReview/${id}`)
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInsuranceCoverTypes() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/GreyFleetInsurance/CoverTypes`)
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    validateInsurance(id) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/employee/GreyFleetInsurance/InternalReview/${id}/Validate`)
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    invalidateInsurance(id, reason) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/employee/GreyFleetInsurance/InternalReview/${id}/Invalidate`, reason)
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInsuranceCheckHistory(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/GreyFleetInsurance/InternalReview/${id}/History`)
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    generateChecksReport(filters, searchTerm) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/LicenceCheckingReports/GreyFleet/Check`, {
                filters: filters,
                searchTerm: searchTerm,
            }).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
};